import {
	Table,
	TableBody,
	TableCell,
	TableFoot,
	TableHead,
	TableHeaderCell,
	TableRow,
	Text,
} from '@mlc/web-ui-toolkit';
import _ from 'lodash';
import React from 'react';
import { AverageInvestorBalance as AverageInvestorBalanceType } from '../../../../../../logic/domains/planProfile.domain';
import { asCurrency, asNumber } from '../../../../../common/formatter';
import planProfileTestIds from '../../PlanProfile.elements';
import { AvgInvestorBalanceContent as content } from './StaticContent';

interface Props {
	asAtDate: string;
	averageInvestorBalance: AverageInvestorBalanceType;
}

interface Demographic {
	ageGroup: string;
	averageBalance: number;
	numberOfInvestors: number;
}

const AvgInvestorBalance: React.FunctionComponent<Props> = props => {
	const mapAgeRanges = (unmappedDemographics: Demographic[]) => {
		let prevAgeGroup = unmappedDemographics[0].ageGroup;
		const mappedDemographics = _.map(
			unmappedDemographics,
			(unmappedDemographic, idx) => {
				const mappedDemographic = { ...unmappedDemographic }; // deep copy to avoid a re-render
				if (idx === 0) {
					mappedDemographic.ageGroup = `<${unmappedDemographics[0].ageGroup}`;
				} else if (idx === unmappedDemographics.length - 1) {
					mappedDemographic.ageGroup = `${prevAgeGroup} and ${unmappedDemographic.ageGroup}`;
				} else {
					mappedDemographic.ageGroup = `${prevAgeGroup} to <${unmappedDemographic.ageGroup}`;
				}
				prevAgeGroup = unmappedDemographic.ageGroup;
				return mappedDemographic;
			}
		) as Demographic[];
		return mappedDemographics;
	};

	return (
		<React.Fragment>
			<Text
				data-id={planProfileTestIds.memberDemoAverageInvestorAsAtDate}
				el="h5"
				fontWeight="semibold"
				marginTop={7}
				marginBottom={4}
			>
				{content.heading}
				{props.asAtDate}
			</Text>
			<Table
				border="mlcBorderThin"
				borderColor="mlcAlmostWhite"
				layout="fixed"
				variant="bottomLines"
			>
				<TableHead>
					<TableRow>
						<TableHeaderCell>{content.table.ageHeader}</TableHeaderCell>
						<TableHeaderCell>{content.table.avgBalanceHeader}</TableHeaderCell>
						<TableHeaderCell>{content.table.investorsHeader}</TableHeaderCell>
					</TableRow>
				</TableHead>
				<TableBody
					data-id={planProfileTestIds.memberDemoAverageInvestor}
					margin={0}
				>
					{_.map(
						mapAgeRanges(props.averageInvestorBalance.ageRanges),
						(demographic, idx) => {
							return (
								<TableRow key={idx}>
									<TableCell
										data-id={planProfileTestIds.memberDemoInvestorAgeGroup}
										scope="row"
										el="th"
									>
										{demographic.ageGroup}
									</TableCell>
									<TableCell
										data-id={
											planProfileTestIds.memberDemoInvestorAverageBalance
										}
									>
										{asCurrency(demographic.averageBalance)}
									</TableCell>
									<TableCell
										data-id={planProfileTestIds.memberDemoInvestorNumber}
									>
										{demographic.numberOfInvestors}
									</TableCell>
								</TableRow>
							);
						}
					)}
				</TableBody>
				<TableFoot data-id={planProfileTestIds.memberDemoInvestorTotal}>
					<TableRow>
						<TableCell el="th" scope="row">
							Total
						</TableCell>
						<TableCell
							data-id={planProfileTestIds.memberDemoInvestorTotalAverageBal}
						>
							{asCurrency(+props.averageInvestorBalance.totalAverageBalance)}
						</TableCell>
						<TableCell
							data-id={planProfileTestIds.memberDemoAverageInvestorTotal}
						>
							{asNumber(props.averageInvestorBalance.totalOfInvestors)}
						</TableCell>
					</TableRow>
				</TableFoot>
			</Table>
		</React.Fragment>
	);
};

export default AvgInvestorBalance;
